<i18n src="./resources/locales.json"></i18n>

<template>
  <v-navigation-drawer
    :value="open"
    :class="{ loading }"
    class="ai-assistance-panel"
    width="480"
    app
    clipped
    fixed
    hide-overlay
    right
    stateless
    temporary
  >
    <v-tabs slider-color="primary" grow>
      <v-tab id="ai-assistance-tab" class="ecs-tab surface lighten-1" href="#ai-assistance-tab">
        <span>
          {{ $t('aiAssistance') }}
        </span>
      </v-tab>
    </v-tabs>

    <div v-if="loading" class="loading-spinner-container">
      <v-progress-circular
        :color="$vuetify.theme.dark ? 'var(--v-accent-base)' : 'var(--v-primary-base)'"
        size="36"
        width="3"
        indeterminate
      />
    </div>
    <iframe
      v-show="!loading"
      v-if="loadIframeOnce"
      class="ai-assistance-iframe"
      :src="url"
      allow="microphone"
      @load="onIframeLoad"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EcsAIAssistance',

  data() {
    return {
      open: false,
      loadIframeOnce: false,
      iframeLoaded: false,
      loading: false
    };
  },

  computed: {
    ...mapGetters('ORGANIZATION', ['customerAIAssistanceBotURL']),

    url() {
      return this.customerAIAssistanceBotURL;
    }
  },

  watch: {
    open(value) {
      if (value) {
        if (!this.iframeLoaded) {
          this.loading = true;
        }
        this.loadIframeOnce = true;
      }
    }
  },

  methods: {
    close() {
      this.open = false;
    },

    toggle() {
      this.open = !this.open;
    },

    onIframeLoad() {
      this.loading = false;
      this.iframeLoaded = true;
    }
  }
};
</script>

<style>
.ai-assistance-panel {
  height: calc(100% - 64px) !important;
  top: 64px !important;
  z-index: 120;
  background-color: #fff !important;
}
.ai-assistance-panel.loading {
  background-color: var(--v-surface-lighten1) !important;
}
.loading-spinner-container {
  display: grid;
  place-items: center;
  height: calc(100vh - 120px);
}
.ai-assistance-panel .ai-assistance-iframe {
  width: 100%;
  height: calc(100vh - 120px);
  border: none;
}
</style>
